export default {"src":"/_next/static/media/no-data.ea4d4cb7.svg","height":162,"width":162,"blurWidth":0,"blurHeight":0};